<template>
  <div id="app" :style="{paddingTop:(currentRoute.path=='/' || currentRoute.path=='/login') ?'0' :'0.375rem' }">
    <RemoteLoginDialog :dialogVisible='dialogVisible' @sure="sure" :time="currentTime" />
    <Header v-if="currentRoute && currentRoute.path!='/' && currentRoute.path!='/login' && isRouterAlive == true" :courseList="courseList" />
    <router-view v-if="isRouterAlive" />
    <Footer v-if="fitlerrout(currentRoute.path) == '-1'" :isLoginPage="( currentRoute.path=='/' || currentRoute.path=='/login') ?true :false" />
  </div>
</template>

<script>
import RemoteLoginDialog from "./components/common/remoteLoginDialog.vue";
import Header from "@/layout/components/Header.vue";
import Footer from "@/layout/components/Footer.vue";
import { userinfo } from "@/api/user";
import { getStore, setStore, clone, isIpad, removeStore, getImageLanguage } from "@/utils/index";
import { heartbeatApi } from "@/api/heartbeat";
import config from '../package.json'
import {setEngStyle} from "@/utils/addEngStyle"
import {getloacllanguage} from "@/utils/pageData"
import { setup } from "@/locales";

export default {
  name: "App",

  provide() {
    return {
      reload: this.reload
    };
  },

  components: {
    Header,
    Footer,
    RemoteLoginDialog
  },
  computed: {
    courseList: function () {
      // console.log("computedcomputedcomputed000", this.$store.state.user.courseList)
      return this.$store.state.user.courseList;
    }
  },
  data() {
    return {
      isRouterAlive: true,
      currentTime: "",
      currentRoute: "",
      timerInterval: "",//用户是否异地登录-定时器
      dialogVisible: false, //是否异地登录
      heartbeatTimer: "",//心跳接口-定时器
    };
  },
  watch: {
    courseList(value) {
      // console.log("watchwatchwatchwatchwatch===", value)
    },
    $route(val, old) {
      // console.log("val====", val)
      // console.log("old====", old)
      if (val) document.title = this.$t('yyxt')
      this.currentRoute = val;
      //非登录页面，如果没有登录-跳转到登录页面
      if (this.currentRoute.path != '/' && this.currentRoute.path != '/login') {
        let userInfo = JSON.parse(getStore("userInfo"));
        if (!userInfo) {
          this.toLoginPage()
        }
      }
      // 移除learningPathMetaId----
      if (this.currentRoute.path == '/home'){
        removeStore("learningPathMetaId")
      }
      if(val.query.language && val.query.language != '' && val.query.language != undefined && val.query.language != null){
        switch (this.$route.query.language) {
          case "zh":
            this.$i18n.locale = 'zh_CN';
            setup("zh_CN");
            window.localStorage.setItem("localeLanguage",'zh_CN')
            break;
          case "en":
            this.$i18n.locale = 'en_US';
            setup("en_US");
            window.localStorage.setItem("localeLanguage",'en_US')
            setEngStyle()
            break;
          case "tw":
            this.$i18n.locale = 'zh_TW';
            setup("zh_TW");
            window.localStorage.setItem("localeLanguage",'zh_TW')
            break;
          case "th":
            this.$i18n.locale = 'th_TH';
            setup("th_TH");
            window.localStorage.setItem("localeLanguage",'th_TH')
            break;
          default:
            break;
        }
      }

      // 心跳mouduId
      setStore('moduleId',val.meta.heart_beat_moduleId ? val.meta.heart_beat_moduleId : null);
    }
  },
  mounted() {
    // console.log("process==", process.env)
    // 监听 resize 方法
    // window.addEventListener("resize", this.renderResize, false)
   
    if(process.env.ENV_CONFIG == 'devOverseas' || process.env.ENV_CONFIG == 'prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod'){
        let icon = 'static/Frame-2905.ico';//  海外图片地址
        this.changeFavicon(icon); // 动态修改网站图标
    }else{
        let icon = 'static/favicon.ico'; // 大陆图片地址
        this.changeFavicon(icon); // 动态修改网站图标
    }
    
    if(getImageLanguage() == 'en'){
      setEngStyle()
    }

  },
  beforeDestroy() {
    // 移除监听
    // window.removeEventListener("resize", this.renderResize, false)
  },
  created() {
    // console.log("created app.vue==")
    this.$EventBus.$on("remoteLogin", data => {
      // console.log("remoteLoginremoteLoginremoteLoginremoteLoginremoteLogin")
      let userInfo = JSON.parse(getStore("userInfo"));
      if (userInfo) {
        this.setDialogVisible()
      } else {
        this.toLoginPage()
      }
      this.$EventBus.$off("remoteLogin", {});
    });

    this.getTimeInter();
    this.toHeartbeatTimer()
  },
  // beforeDestroy() {
  // if (this.timerInterval) {
  //   clearInterval(this.timerInterval); //关闭
  // }
  // if (this.heartbeatTimer) {
  //   clearInterval(this.heartbeatTimer); //关闭
  // }
  // },
  methods: {
    fitlerrout(data) {
      // console.log("fitlerrout==", data)
      return data ? data.search("course") : 1
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true;
        // this.courseList = this.$store.state.user.courseList;
      })

    },
    changeFavicon(link) {
        document.title=this.$t('yyxt');
        let $favicon = document.querySelector('link[rel="icon"]');
        // If a <link rel="icon"> element already exists,
        // change its href to the given link.
        if ($favicon !== null) {
          $favicon.href = link;
        } else {
          $favicon = document.createElement("link");
          $favicon.rel = "icon";
          $favicon.href = link;
          document.head.appendChild($favicon);
        }
    },
    renderResize() {
      // 判断横竖屏
      // let width = document.documentElement.clientWidth
      // let height = document.documentElement.clientHeight
      // console.log("width==", width)
      // if (isIpad()) {
      //   // 刷新页面更新视图
      //   this.isRouterAlive = false
      //   this.$nextTick(function(){
      //       this.isRouterAlive = true

      //   })
      // }
      // if(width > height) {
      //     alert('横屏')
      // }
      // 做页面适配
      // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
    },
    // 获取浏览器信息
    getClientInfo() {
      //客户端信息
      let clientInfo = {
        referrer: document.referrer,//来源
        timeOpened: new Date().getTime(), //客户端时间戳
        timezone: new Date().getTimezoneOffset(),//本地时间与 GMT 时间之间的时间差
        pageon: location.pathname,
        previousSites: history.length,//历史堆栈的数量
        browserName: navigator.appName,//浏览器名称
        browserEngine: navigator.product,//引擎
        browserVersion1a: navigator.appVersion,//浏览器版本
        browserVersion1b: navigator.userAgent,//用户代理
        browserLanguage: navigator.language,//语言
        browserOnline: navigator.onLine,//是否在线
        browserPlatform: navigator.platform,//平台
        javaEnabled: navigator.javaEnabled(),
        dataCookies: (document.cookie.match(/[^\s;]+/g) || []).map(item => encodeURI(item)),//cookie
        sizeScreenW: screen.width, //显示器尺寸
        sizeScreenH: screen.height, //显示器尺寸
        sizeDocW: document.documentElement.clientWidth,//页面可视区的宽度
        sizeDocH: document.documentElement.clientHeight, //页面可视区的高度
        sizeInW: window.innerWidth, //窗口的宽度
        sizeInH: window.innerHeight,//窗口的高度
        sizeAvailW: screen.availWidth, //浏览器的屏幕的可用宽度
        sizeAvailH: screen.availHeight,//浏览器的屏幕的可用高度
        scrColorDepth: screen.colorDepth,  //设备调色板比特深度
        scrPixelDepth: screen.pixelDepth,//屏幕色彩分辨率
        //地理位置信息
        latitude: "",
        longitude: "",
        accuracy: "",
        altitude: "",
        altitudeAccuracy: "",
        heading: "",
        speed: "",
        timestamp: Date.now()
      };
      return clientInfo
    },

    //心跳接口
    requestHeartbeat() {
      let appId = '1739e28a7bc200'
      
      //海外版
      if (process.env.ENV_CONFIG == 'devOverseas' || process.env.ENV_CONFIG == 'prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod') {
        // return
        appId = '1739e28a7bc200'
        if (process.env.ENV_CONFIG == 'thprod' || process.env.ENV_CONFIG == 'prodOverseas') {
          appId = '1739e28a7bc279'
        }
      } else {
        // 大陆
        appId = '1739e28a7bc100'
        if (process.env.ENV_CONFIG == 'prod') {
          appId = '1739e28a7bc179'
        }
      }

      //情景模拟页面
      if (this.currentRoute.path == '/course/scenarioSimulationNew') {
        return
      }

      
      let learningPathMetaId = getStore("learningPathMetaId") ? getStore("learningPathMetaId") : '';
      let userInfo = JSON.parse(getStore("userInfo"));
      let userId = (userInfo && userInfo.userId) ? userInfo.userId : ""
      if (!userId) {
        return
      }
      let clientInfo = this.getClientInfo()
      // console.log("userInfo===", userInfo)
      // console.log("clientInfo===", clientInfo)
      // console.log("this.$router===", this.$router)
      // console.log("this.currentRoute===", this.currentRoute)
      let router = this.$router.history.current.fullPath
      if (!router || router == '/') {
        router = '/login'
      }
      let language = '';
      switch(window.localStorage.getItem("localeLanguage")){
        case 'zh_CN':
          language = 'zh'
          break;
        case 'en_US':
          language = 'en'
          break;
        case 'zh_TW':
          language = 'tw'
          break;
        case 'th_TH':
          language = 'th'
          break;
        default:
          break;
      }
      let params = {
        actionContext: "",
        actionId: "1000",
        appId: appId,
        appName: "transtalent_pc",
        appVersion: "v." + config.version + '-INTpc_' + language,
        learningPathMetaId: learningPathMetaId,
        result: "",
        userId: userId,
        objectIds: [router,localStorage.getItem('moduleId')?Number(localStorage.getItem('moduleId')) : null],
        clientInfo: clientInfo
      }
      // console.log("paramsparams==", params)
      heartbeatApi(params).then(res => {
        // console.log(" ----- heartbeat ----", res);
      },
        err => {
        }
      );

    },

    toHeartbeatTimer() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer); //关闭
      }
      let that = this;
      this.heartbeatTimer = setInterval(() => {
        that.requestHeartbeat()
      }, 30 * 1000);
    },

    getTimeInter() {
      let that = this;
      let timerInterval = setInterval(() => {
        if (that.currentRoute.path == '/' || that.currentRoute.path == '/login' || that.currentRoute.path == '/companyList') {
          return
        }
        let userInfo = JSON.parse(getStore("userInfo"));
        if (userInfo && userInfo.userId) {
          that.getInterval();
          clearInterval(timerInterval); //关闭
        }
      }, 5000);
    },

    // 获取间隔时间
    getInterval() {
      this.$api.intervalValue().then(res => {
        console.log(" ----- intervalValue ----", res);
        this.toTimerInterval(res);
      },
        err => {
          this.toTimerInterval(30);
        }
      );
    },

    toTimerInterval(interval) {
      console.log("toTimerInterval===", interval)
      if (this.timerInterval) {
        clearInterval(this.timerInterval); //关闭
      }
      let that = this;
      this.timerInterval = setInterval(() => {
        if (getStore("userInfo")) {
          let userInfo = JSON.parse(getStore("userInfo"));
          if (userInfo && userInfo.userId) {
            that.getUserinfo();
          }
        }
      }, interval * 1000);
    },

    // 判断异地登录
    getUserinfo() {
      if (this.dialogVisible) {
        return;
      }
      userinfo({}).then(res => {
      },
        err => {
          if (err.code = 106) {
            // this.setDialogVisible()
          }
        }
      );
    },

    setDialogVisible() {
      setStore("userInfo", null);
      if (this.dialogVisible) {
        return
      }
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      this.currentTime = hh + ':' + mf;
      this.dialogVisible = true;
    },

    sure() {
      setStore("userInfo", null);
      this.dialogVisible = false;
      this.$router.replace({ 
        path: "/login",
        query:{
          language: getloacllanguage()
        }
      });
    },
    toLoginPage() {
      setStore("userInfo", null);
      this.$router.replace({ 
        path: "/login",
        query:{
          language: getloacllanguage()
        }
      });
    },
    
  }
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  /* color: #2c3e50; */
  /* padding-top: 85px; */
}
</style>





// WEBPACK FOOTER //
// src/App.vue